














































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { FamilyMemberRelationship, FamilyMemberStatus } from "@/shared/types";

@Component({
  components: { }
})
export default class DependentTableView extends Vue {
  formatDateString = formatMMddyyyyDateString;

  @Prop ()
  dependents;

  @Prop ({required: false, default: true})
  isActive: boolean;

  collapseId (id) {
    return `collapse-${id}`;
  }

  toggleDetails (id) {
    this.$root.$emit("bv::toggle::collapse", id);
    this.toggleCollapsedClass(id);
  }

  toggleCollapsedClass (id) {
    const elem = document.getElementById(id);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  middleInitial (dependent) {
    if (dependent.middleInitial) {
      return dependent.middleInitial;
    }
    return "";
  }

  fullName (dependent): string {
    return `${dependent.firstName} ${this.middleInitial(dependent)} ${dependent.lastName}`;
  }

  dateOfBirth (dependent): string {
    return this.formatDateString(dependent.dateOfBirth);
  }

  relationship (dependent): string {
    switch (dependent.relationship) {
      case FamilyMemberRelationship.Dependent:
        return "Dependent";
      case FamilyMemberRelationship.Spouse:
        return "Spouse";
      default:
        return "";
    }
  }

  status (dependent): string {
    switch (dependent.status) {
      case FamilyMemberStatus.Active:
        return "Active";
      case FamilyMemberStatus.Inactive:
        return "Inactive";
      default:
        return "";
    }
  }

  lastFourSsn (dependent): string {
    const ssnLength = dependent.ssn ? dependent.ssn.length : undefined;
    if (ssnLength) {
      return `***-**-${dependent.ssn.substring(7, ssnLength)}`;
    }

    return "";
  }
}
